import { render, staticRenderFns } from "./CommentEditor.vue?vue&type=template&id=b229a522&"
import script from "./CommentEditor.vue?vue&type=script&lang=js&"
export * from "./CommentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b229a522')) {
      api.createRecord('b229a522', component.options)
    } else {
      api.reload('b229a522', component.options)
    }
    module.hot.accept("./CommentEditor.vue?vue&type=template&id=b229a522&", function () {
      api.rerender('b229a522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments/CommentEditor.vue"
export default component.exports